import { Input } from "@/components/ui/input";
import DependentQuestions from "@/containers/survey/components/DependentQuestions";
import { useTranslation } from "react-i18next";
import Field from "@/components/Field";
import ValidationTypeSelect from "../../ValidationTypeSelect";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionInputProps {
  index: number;
}

const QuestionInput = ({ index }: QuestionInputProps) => {
  const { t } = useTranslation();
  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.validation`}
        required={isRequired(cfg.shape.validation)}
        label={t("surveyEditor.validationLabel")}
        render={({ field }) => <ValidationTypeSelect {...field} />}
      />
      <Field
        name={`questions.${index}.cfg.minLength`}
        required={isRequired(cfg.shape.minLength)}
        label={t("surveyEditor.common.minLength")}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <Field
        name={`questions.${index}.cfg.maxLength`}
        required={isRequired(cfg.shape.maxLength)}
        label={t("surveyEditor.common.maxLength")}
        render={({ field }) => (
          <Input type="number" className="w-24" {...field} />
        )}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionInput;
